import { appConstantSettings } from 'srcReact/appConstantSettings'
import { discoverConstants as dc } from 'srcReact/DiscoverPage'
import { discoverService } from 'srcReact/services'

const PAGINATION_QUANTITY = appConstantSettings.PAGINATION_QUANTITY
const MIXR_PAGINATION_QUANTITY = appConstantSettings.MIXR_PAGINATION_QUANTITY

export const discoverActions = {
  getDiscoverAll,
  getDiscoverMixrList,
  getDiscoverMixrListPagination,
  getDiscoverGroupList,
  getDiscoverGroupListPagination
}

function getDiscoverAll(
  id_workplace,
  group_list_latitude = 0,
  group_list_longitude = 0,
  mixr_list_latitude = 0,
  mixr_list_longitude = 0,
  group_list_order_by = 'bestmatch',
  mixr_list_order_by = 'upcoming',
  group_list_offset = 0,
  mixr_list_offset = 0,
  group_list_quantity = PAGINATION_QUANTITY,
  mixr_list_quantity = MIXR_PAGINATION_QUANTITY
) {
  return (dispatch) => {
    dispatch(
      request({
        id_workplace,
        group_list_order_by,
        group_list_latitude,
        group_list_longitude,
        group_list_offset,
        group_list_quantity,
        mixr_list_order_by,
        mixr_list_latitude,
        mixr_list_longitude,
        mixr_list_offset,
        mixr_list_quantity
      })
    )

    discoverService
      .getDiscoverAll(
        id_workplace,
        group_list_order_by,
        group_list_latitude,
        group_list_longitude,
        group_list_offset,
        group_list_quantity,
        mixr_list_order_by,
        mixr_list_latitude,
        mixr_list_longitude,
        mixr_list_offset,
        mixr_list_quantity
      )
      .then(
        (response) => {
          dispatch(success(response))
        },
        (error) => {
          dispatch(failure(error))
        }
      )
  }

  function request(data) {
    return { type: dc.GET_DISCOVER_ALL_REQUEST, data }
  }
  function success(data) {
    return { type: dc.GET_DISCOVER_ALL_SUCCESS, data }
  }
  function failure(error) {
    return { type: dc.GET_DISCOVER_ALL_FAILURE, error }
  }
}

function getDiscoverMixrList(
  id_workplace,
  order_by = 'upcoming',
  latitude = 0,
  longitude = 0,
  offset = 0,
  quantity = MIXR_PAGINATION_QUANTITY
) {
  return (dispatch) => {
    dispatch(request({ id_workplace, order_by, latitude, longitude, offset, quantity }))

    discoverService.getMixrList(id_workplace, order_by, latitude, longitude, offset, quantity).then(
      (response) => {
        dispatch(success(response))
      },
      (error) => {
        dispatch(failure(error))
      }
    )
  }

  function request(data) {
    return { type: dc.GET_DISCOVER_MIXR_LIST_REQUEST, data }
  }
  function success(data) {
    return { type: dc.GET_DISCOVER_MIXR_LIST_SUCCESS, data }
  }
  function failure(error) {
    return { type: dc.GET_DISCOVER_MIXR_LIST_FAILURE, error }
  }
}

function getDiscoverMixrListPagination(
  id_workplace,
  order_by = 'upcoming',
  latitude = 0,
  longitude = 0,
  offset = 0,
  quantity = MIXR_PAGINATION_QUANTITY
) {
  return (dispatch) => {
    dispatch(request({ id_workplace, order_by, latitude, longitude, offset, quantity }))

    discoverService.getMixrList(id_workplace, order_by, latitude, longitude, offset, quantity).then(
      (response) => {
        dispatch(success(response))
      },
      (error) => {
        dispatch(failure(error))
      }
    )
  }

  function request(data) {
    return { type: dc.GET_DISCOVER_MIXR_LIST_PAGINATION_REQUEST, data }
  }
  function success(data) {
    return { type: dc.GET_DISCOVER_MIXR_LIST_PAGINATION_SUCCESS, data }
  }
  function failure(error) {
    return { type: dc.GET_DISCOVER_MIXR_LIST_PAGINATION_FAILURE, error }
  }
}

// function getDiscoverStats(id_workplace) {
//   return (dispatch) => {
//     dispatch(request({ id_workplace }))

//     discoverService.getStats(id_workplace).then(
//       (response) => {
//         dispatch(success(response))
//       },
//       (error) => {
//         dispatch(failure(error))
//       }
//     )
//   }

//   function request(data) {
//     return { type: dc.GET_DISCOVER_STATS_REQUEST, data }
//   }
//   function success(data) {
//     return { type: dc.GET_DISCOVER_STATS_SUCCESS, data }
//   }
//   function failure(error) {
//     return { type: dc.GET_DISCOVER_STATS_FAILURE, error }
//   }
// }

function getDiscoverGroupList(
  id_workplace,
  order_by = 'allgroups',
  latitude = 0,
  longitude = 0,
  offset = 0,
  quantity = PAGINATION_QUANTITY
) {
  return (dispatch) => {
    dispatch(request({ id_workplace, order_by, latitude, longitude, offset, quantity }))

    discoverService.getGroupList(id_workplace, order_by, latitude, longitude, offset, quantity).then(
      (response) => {
        dispatch(success(response))
      },
      (error) => {
        dispatch(failure(error))
      }
    )
  }

  function request(data) {
    return { type: dc.GET_DISCOVER_GROUP_LIST_REQUEST, data }
  }
  function success(data) {
    return { type: dc.GET_DISCOVER_GROUP_LIST_SUCCESS, data }
  }
  function failure(error) {
    return { type: dc.GET_DISCOVER_GROUP_LIST_FAILURE, error }
  }
}

function getDiscoverGroupListPagination(
  id_workplace,
  order_by = 'allgroups',
  latitude = 0,
  longitude = 0,
  offset = 0,
  quantity = PAGINATION_QUANTITY
) {
  return (dispatch) => {
    dispatch(request({ id_workplace, order_by, latitude, longitude, offset, quantity }))

    discoverService.getGroupList(id_workplace, order_by, latitude, longitude, offset, quantity).then(
      (response) => {
        dispatch(success(response))
      },
      (error) => {
        dispatch(failure(error))
      }
    )
  }

  function request(data) {
    return { type: dc.GET_DISCOVER_GROUP_LIST_PAGINATION_REQUEST, data }
  }
  function success(data) {
    return { type: dc.GET_DISCOVER_GROUP_LIST_PAGINATION_SUCCESS, data }
  }
  function failure(error) {
    return { type: dc.GET_DISCOVER_GROUP_LIST_PAGINATION_FAILURE, error }
  }
}
